/** @format */
import axios from "axios";
import CheckToken from "../../../utils/checkToken/CheckToken";

/**
 * Alt kullanıcıyı güncelleme işlemi için API çağrısı yapar
 * @param {object} data - Güncellenecek kullanıcı verileri
 * @param {string} data.id - Güncellenecek alt kullanıcının ID'si
 * @returns {Promise} - API yanıtını döndürür
 */
export const updateSubUser = async (data) => {
  const token = await CheckToken();
  if (!token) {
    // Oturum yoksa login sayfasına yönlendir
    window.location.href = "/login";
  }

  // data içinden id'yi ayrı olarak al
  const { id, ...updateData } = data;
  console.log(updateData, "updateData");
  // PATCH isteği yaparak ilgili endpoint'e veriyi gönder
  return await axios.patch(
    `${process.env.REACT_APP_API_URL}/users/update-subuser/${id}`,
    updateData,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};
